export default "__VITE_ASSET__BKMTsmhP__"